var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1726_463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000915527H21V19.0009H0V0.000915527Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1726_463)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5002 2.00188C5.81318 2.00188 2.00018 4.91788 2.00018 8.50188C2.00018 10.3159 3.00518 12.0649 4.75618 13.2929C4.92818 13.4139 5.00618 13.6289 4.95218 13.8319C4.83518 14.2679 4.43718 15.4649 3.37218 16.6209C4.67418 16.1639 6.07618 15.3729 7.11118 14.6619C7.23418 14.5759 7.38818 14.5509 7.53218 14.5919C8.48018 14.8629 9.47918 15.0019 10.5002 15.0019C15.1872 15.0019 19.0002 12.0859 19.0002 8.50188C19.0002 4.91788 15.1872 2.00188 10.5002 2.00188ZM1.50018 18.0019C1.27518 18.0019 1.07818 17.8519 1.01818 17.6349C0.958176 17.4179 1.05018 17.1879 1.24318 17.0719C2.93418 16.0589 3.63518 14.5839 3.88418 13.8929C2.04618 12.4859 1 10.5389 1 8.50188C1 7.47288 1.25818 6.47488 1.76818 5.53688C2.25418 4.64288 2.94818 3.84188 3.82918 3.15588C5.61618 1.76588 7.98518 0.999878 10.5002 0.999878C13.0152 0.999878 15.3842 1.76588 17.1712 3.15588C18.0522 3.84188 18.7462 4.64288 19.2322 5.53688C19.7422 6.47488 20.0002 7.47088 20.0002 8.50188C20.0002 9.53088 19.7422 10.5269 19.2322 11.4649C18.7462 12.3589 18.0522 13.1599 17.1712 13.8459C15.3842 15.2359 13.0152 16.0019 10.5002 16.0019C9.46718 16.0019 8.45318 15.8729 7.48418 15.6169C7.05518 15.9039 6.25318 16.4099 5.29518 16.8869C3.80718 17.6269 2.53118 18.0019 1.50118 18.0019H1.50018Z",
    fill: "#001533",
    stroke: "#001533",
    strokeWidth: 0.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5005 9.50195C10.2245 9.50195 10.0005 9.2957 10.0005 9.04362V4.46029C10.0005 4.20637 10.2245 4.00195 10.5005 4.00195C10.7765 4.00195 11.0005 4.20637 11.0005 4.46029V9.04362C11.0005 9.2957 10.7765 9.50195 10.5005 9.50195Z",
    fill: "#888888",
    stroke: "#888888",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5005 12.5001C10.2245 12.5001 10.0005 12.2751 10.0005 12.0001V11.0001C10.0005 10.7231 10.2245 10.5001 10.5005 10.5001C10.7765 10.5001 11.0005 10.7231 11.0005 11.0001V12.0001C11.0005 12.2751 10.7765 12.5001 10.5005 12.5001Z",
    fill: "#888888",
    stroke: "#888888",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMessage);
export default __webpack_public_path__ + "static/media/menu_message.43573836935fa75af6de78e47ba16dfe.svg";
export { ForwardRef as ReactComponent };